import logo200Image from '../assets/img/logo/logo_2.png';
import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Typography from '../components/Typography';
import axios from '../utils/posAxios';
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md';
import Avatar from '../components/Avatar';
import userPlaceholder from '../assets/img/users/profile.jpg';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { getTax } from '../utils/dropdownlist';
import update from 'immutability-helper';

class PosPriceModeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      productList: [],
      id: '',
      store_id: '',
      product_id: '',
      price_data: [{ unit: '', price: '0.00' }],
      min_qty: '0',
      max_qty: '0',
      start_dt: '',
      end_dt: '',
    };
  }

  componentDidMount() {
    const data = this.props.data;
    if (this.props.data.isEdit) {
      let id = this.props.data.selectedId;
      const price_mode = this.props.data.price_mod.find(e => e.id === id);
      console.log(this.props);
      this.setState({
        isEdit: true,
        id: id,
        store_id: data.store_id,
        product_id: data.product_id,
        product_no: data.product_no,
        price_data: JSON.parse(price_mode.price_data),
        min_qty: price_mode.min_qty,
        max_qty: price_mode.max_qty,
        start_dt: price_mode.start_dt,
        end_dt: price_mode.end_dt,
      });
    } else {
      this.setState({
        store_id: data.store_id,
        product_id: data.product_id,
      });
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  priceChangeHandler = event => {
    const { name, value } = event.target;
    this.setState({
      price_data: update(this.state.price_data, {
        0: { [name]: { $set: value } },
      }),
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    if (this.state.isEdit) {
      this.editPriceMode(user, url);
    } else {
      this.addPriceMode(user, url);
    }
  };

  editPriceMode(user, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      price_id: this.state.id,
      store_id: this.state.store_id,
      price_data: JSON.stringify(this.state.price_data),
      min_qty: this.state.min_qty,
      max_qty: this.state.max_qty,
      start_dt: this.state.start_dt,
      end_dt: this.state.end_dt,
      update_by: user.email,
    };
    axios
      .post(url + ':3002/v1/product/store/detail/price_mod/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Price Mode updated successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  addPriceMode(user, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      product_id: this.state.product_id,
      price_data: JSON.stringify(this.state.price_data),
      min_qty: this.state.min_qty,
      max_qty: this.state.max_qty,
      start_dt: this.state.start_dt,
      end_dt: this.state.end_dt,
      created_by: user.email,
    };
    axios
      .post(url + ':3002/v1/product/store/detail/price_mod/add', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Price Mode added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    let { price_data } = this.state;
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Price Mode Details
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="price">Price</Label>
                <Input
                  type="number"
                  name="price"
                  value={price_data[0] && price_data[0].price}
                  onChange={this.priceChangeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="min_qty">Min Quantity</Label>
                <Input
                  type="text"
                  name="min_qty"
                  value={this.state.min_qty}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label for="max_qty">Max Quantity</Label>
                <Input
                  type="text"
                  name="max_qty"
                  value={this.state.max_qty}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="start_dt">Start Date</Label>
                <Input
                  type="date"
                  name="start_dt"
                  value={this.state.start_dt}
                  onChange={this.changeHandler}
                />
              </FormGroup>
              <FormGroup>
                <Label for="end_dt">End Date</Label>
                <Input
                  type="date"
                  name="end_dt"
                  value={this.state.end_dt}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default PosPriceModeForm;
